export const PopoverDT = {
	popover: {
		css: ({ dt }) => `
              .p-popover-no-padding {
                .p-popover-content {
                    padding: 0;
                }
              }
        `,
	},
};
